const EVENT_ID_PATTERN = /^[A-Za-z0-9._-]{8,128}$/;
export const FINGERPRINT_ERROR_MESSAGE =
  "Não foi possível identificar o dispositivo";

export function isFingerprintEnabled() {
  return String(process.env.VUE_APP_FINGERPRINT_ENABLED || "")
    .trim()
    .toLowerCase() === "true";
}

export function createFingerprintPluginOptions(apiKey) {
  const normalizedApiKey = String(apiKey || "").trim();
  if (!normalizedApiKey) {
    throw new Error("Fingerprint não configurado");
  }

  return {
    apiKey: normalizedApiKey,
    region: "us",
  };
}

export async function getFingerprintEventId(getData) {
  if (!isFingerprintEnabled()) {
    return null;
  }

  let result;
  try {
    result = await getData();
  } catch {
    throw new Error(FINGERPRINT_ERROR_MESSAGE);
  }
  const eventId = String(result?.event_id || "").trim();
  if (!EVENT_ID_PATTERN.test(eventId)) {
    throw new Error(FINGERPRINT_ERROR_MESSAGE);
  }

  return eventId;
}

export async function getFingerprintEventHeaders(getData) {
  const eventId = await getFingerprintEventId(getData);
  if (!eventId) {
    return {};
  }

  return {
    "X-Fingerprint-Event-Id": eventId,
  };
}
